import { render } from "./HeaderInfoText.vue?vue&type=template&id=669aeac0&scoped=true"
import script from "./HeaderInfoText.vue?vue&type=script&lang=js"
export * from "./HeaderInfoText.vue?vue&type=script&lang=js"

import "./HeaderInfoText.vue?vue&type=style&index=0&id=669aeac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669aeac0"]])

export default __exports__